/* Do not import this function directly - use through importing guards.js */

/**
 * Execute multiple guard functions in series using a dynamically generated guard function.
 *
 * @returns {Function} A guard function taking to, from and next parameters.
 */
export default function(guards) {
    return async function(to, from, next) {
        if (!guards || !guards.length) {
            next()
        } else if (guards.length == 1) {
            await guards[0](to, from, next)
        } else {
            const executeGuard = async function(g, firstIndex, t, f, nextFunc) {
                await g[firstIndex](to, from, async(route) => {
                    if (route)
                        nextFunc(route)
                    else if (g[firstIndex+2])
                        await executeGuard(g, firstIndex+1, t, f, next)
                    else
                        await g[firstIndex+1](t, f, next)
                })
            }

            await executeGuard(guards, 0, to, from, next)
        }
    }
}
